import PropTypes from 'prop-types';

import {OEVHLayoutType} from '../../../lib/components/oe-vh-layouter';

export const OEBottomWidgetToolbarWidgetType = {
    presentationSlide: 'presentationSlide',
    mediaCenterItem: 'mediaCenterItem'
};

export const OEBottomWidgetToolbarLayoutType = OEVHLayoutType;

export class OEBottomWidgetToolbarConfigFactory {

    constructor(enabled = true, allowedLayoutTypes = OEBottomWidgetToolbarLayoutType.all, widgets = []) {
        this.setEnabled(enabled);
        this.setAllowedLayoutTypes(allowedLayoutTypes);
        this.setWidgets(widgets);
    }

    clear() {
        this.setEnabled(true);
        this.setAllowedLayoutTypes(OEBottomWidgetToolbarLayoutType.all);
        this.setWidgets([]);
        return this;
    }

    setEnabled(enabled) {
        this._enabled = !!enabled;
        return this;
    }

    setAllowedLayoutTypes(layouts) {
        this._allowedLayoutTypes = Array.isArray(layouts) ? layouts : OEBottomWidgetToolbarLayoutType.all;
        return this;
    }

    setWidgets(widgets) {
        this._widgets = Array.isArray(widgets) ? widgets : [];
        return this;
    }

    setSingleType(type, props)    {
        this.setEnabled(typeof(type) === 'string');

        let widgets = [];

        if(type === OEBottomWidgetToolbarWidgetType.mediaCenterItem)    {
            widgets.push({
                type: OEBottomWidgetToolbarWidgetType.mediaCenterItem,
                props: Object.assign({
                    category: 0
                }, props)
            });
        } else if(type === OEBottomWidgetToolbarWidgetType.presentationSlide)    {
            widgets.push({
                type: OEBottomWidgetToolbarWidgetType.presentationSlide,
                props: Object.assign({
                    defaultPresentation: 0
                }, props)
            });
        }

        this.setWidgets(widgets);
        return this;
    }

    build() {
        return {
            enabled: this._enabled,
            allowedLayoutTypes: Array.isArray(this._allowedLayoutTypes) ? this._allowedLayoutTypes : [],
            widgets: this._widgets
        };
    }
}

export const OEBottomWidgetToolbarPropTypes = {

    config: PropTypes.shape({
        enabled: PropTypes.bool,
        allowedLayoutTypes: PropTypes.arrayOf(PropTypes.oneOf(OEBottomWidgetToolbarLayoutType.all)),
        widgets: PropTypes.arrayOf(PropTypes.shape({
            type: PropTypes.string.isRequired,
            props: PropTypes.shape({
                // presentationSlide
                defaultPresentation: PropTypes.number,  // int
                // mediaCenterItem
                category: PropTypes.number,             // int
                categoryName: PropTypes.string,
                categoryMaskOrder: PropTypes.arrayOf(PropTypes.number),
                selectActive: PropTypes.bool,
                showIndex: PropTypes.bool,
                showIcon: PropTypes.bool,
                showLabel: PropTypes.bool,
                showStats: PropTypes.bool,
                noImages: PropTypes.bool,
                noPresThumbImages: PropTypes.bool,
                autoplay: PropTypes.bool,
            })
        }))
    })
};